module.exports = __webpack_public_path__ + "img/qtv-slides-1-new.568fe8dd.png";